import React, {Component} from 'react';
import {Tag, Input, Tooltip, Icon, Form} from 'antd';

class ButtonInput extends Component {

    static defaultProps = {
        maxLength: 20,
        inputWidth: 150,
        firstClosable: true
    };

    constructor(props) {
        super(props);
        this.state={
            tags: props.itemValue||[window.currentUser.name],
            inputVisible: false,
            inputValue: '',
        }
    }
    componentDidMount() {

    }

    handleClose = removedTag => {
        const tags = this.state.tags.filter(tag => tag !== removedTag);
        this.setState({ tags },()=>{
            this.props.callBack&& this.props.callBack(tags)
        });
    };

    showInput = () => {
        this.setState({ inputVisible: true }, () => this.input.focus());
    };

    handleInputChange = e => {
        this.setState({ inputValue: e.target.value });
    };

    handleInputConfirm = () => {
        const { inputValue } = this.state;
        let { tags } = this.state;
        if (inputValue && tags.indexOf(inputValue) === -1) {
            if(inputValue.replace(/^ +| +$/g,'') !== ''){
                tags = [...tags, inputValue];
            }
        }
        this.setState({
            tags,
            inputVisible: false,
            inputValue: '',
        },()=>{
            this.props.callBack&& this.props.callBack(tags)
        });
    };

    saveInputRef = input => (this.input = input);
    render() {
        const { tags, inputVisible, inputValue } = this.state;
        return (
            <Form.Item label={this.props.label} required={this.props.empty} style={{display:"flex"}}>
                <div style={{maxWidth:"642px"}}>
                    {tags.map((tag, index) => {
                        const isLongTag = tag.length > 20;
                        if((index === 0) && !this.props.itemValue){
                            this.props.callBack && this.props.callBack([tag])
                        }
                        const tagElem = (
                            <Tag key={tag} closable={this.props.firstClosable ? (index !== 0) : true} onClose={() => this.handleClose(tag)} style={{height:"32px",lineHeight:"32px"}}>
                                {isLongTag ? `${tag.slice(0, 20)}...` : tag}
                            </Tag>
                        );
                        return isLongTag ? (
                            <Tooltip title={tag} key={tag}>
                                {tagElem}
                            </Tooltip>
                        ) : (
                            tagElem
                        );
                    })}
                    {inputVisible && (
                        <Input
                            ref={this.saveInputRef}
                            type="text"
                            size="small"
                            style={{ width: this.props.inputWidth,height:"32px"}}
                            value={inputValue}
                            onChange={this.handleInputChange}
                            onBlur={this.handleInputConfirm}
                            onPressEnter={this.handleInputConfirm}
                            maxLength={this.props.maxLength}
                        />
                    )}
                    {!inputVisible && (
                        <Tag onClick={this.showInput} style={{background: '#fff', borderStyle: 'dashed',height:"32px",lineHeight:"32px" }}>
                            <Icon type="plus" /> 添加
                        </Tag>
                    )}
                </div>
            </Form.Item>
        );
    }
}

export default ButtonInput;
